export const CHANGE_STAKE = "CHANGE_STAKE";
export const CHANGE_CURRENT_GAME = "CHANGE_CURRENT_GAME";
export const CHANGE_LOTTERY_PRIZE = "CHANGE_LOTTERY_PRIZE";
